export const DATASETS_STATUSES = {
  inProgress: 'in_progress',
  finished: 'finished',
  partiallyFinished: 'partially-finished'
}

export const DATABASE_STATUSES = {
  completed: 'completed'
}

export const MAX_CHECKS_ALLOWED = 3
